<form
  [formGroup]="form"
  (ngSubmit)="confirm()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div class="flex w-full justify-between gap-4 py-4 border-b border-neutral-300">
      <span class="text-[18px] font-black">
        <i
          class="pi pi-file-edit"
          style="font-size: 2rem"></i>
        SUBSANACION DE DESPLIEGUE DE SISTEMA
      </span>
      <div class="flex gap-4">
        <app-buttons
          [label]="'Detalle de subsanación'"
          (click)="goToSummary()" />
        <app-buttons
          [label]="'Volver al paso anterior'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Continuar'"
          [disabled]="form.invalid || hasPendingObservedFieldsInStep()"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 4 de 6</span>
      <h2 class="font-bold text-[24px] pb-6">Cumplimiento ISO 42001</h2>

      <h3 class="font-bold text-[18px] pb-4">Sistema de gestión de IA</h3>

      <div class="grid grid-cols-2">
        <div class="flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('iso42001')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="iso42001"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('iso42001') }">
              Validación contra controles ISO 42001*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay validación
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'iso42001', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
          <ng-container *ngIf="!iso42001ExtraFilled() && iso42001Required()">
            <desy-error-message class="block font-semibold">
              Rellena obligatoriamente uno de los dos campos siguientes:
            </desy-error-message>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="iso42001Required()">
        <div class="grid grid-cols-2 mt-2">
          <div class="flex flex-col relative">
            <span
              class="text-[14px] text-neutral-dark"
              [ngClass]="{ 'relative -top-2': isObserved('iso42001Csv') }">
              Con CSV
            </span>
            <app-observed-field-alert
              *ngIf="isObserved('iso42001Csv')"
              class="absolute top-2 left-0"></app-observed-field-alert>
            <desy-input
              id="iso42001Csv"
              [classes]="'w-full'"
              [placeholder]="'Validación 1, validación 2...'"
              formControlName="iso42001Csv"></desy-input>
          </div>
        </div>
        <div class="flex flex-col relative">
          <span
            class="text-[14px] text-neutral-dark block"
            [ngClass]="{ 'relative -top-2': isObserved('iso42001Description') }">
            Descripción
          </span>
          <app-observed-field-alert
            *ngIf="isObserved('iso42001Description')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="iso42001Description"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la validación contra controles ISO 42001'"
            formControlName="iso42001Description"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
        </div>
      </ng-container>

      <h2 class="font-bold text-[24px] mt-4 pb-4">Cumplimiento Orden HAP/796/2025</h2>

      <h3 class="font-bold text-[18px] pb-6">Principios básicos</h3>

      <div class="grid grid-cols-2">
        <div class="flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('dataSovereignty')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="dataSovereignty"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('dataSovereignty') }">
              Soberanía del dato protegida*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay soberanía
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'dataSovereignty', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="dataSovereigntyRequired()">
        <div class="flex flex-col -mt-2 mb-2 relative">
          <desy-label [ngClass]="{ 'relative -top-4': isObserved('dataSovereigntyDescription') }">
            Descripción*
          </desy-label>
          <app-observed-field-alert
            *ngIf="isObserved('dataSovereigntyDescription')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="dataSovereigntyDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la soberanía del dato protegida'"
            formControlName="dataSovereigntyDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="
              getError(form, 'dataSovereigntyDescription', formSubmitted()) as error;
              else dataSovereigntyDescriptionInfo
            ">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #dataSovereigntyDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>

      <div class="grid grid-cols-2">
        <div class="flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('equityAndAccess')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="equityAndAccess"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('equityAndAccess') }">
              Equidad y acceso universal verificado*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay equidad
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'equityAndAccess', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="equityAndAccessRequired()">
        <div class="flex flex-col -mt-2 mb-2 relative">
          <desy-label [ngClass]="{ 'relative -top-4': isObserved('equityAndAccessDescription') }">
            Descripción*
          </desy-label>
          <app-observed-field-alert
            *ngIf="isObserved('equityAndAccessDescription')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="equityAndAccessDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la equidad y acceso universal verificado'"
            formControlName="equityAndAccessDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="
              getError(form, 'equityAndAccessDescription', formSubmitted()) as error;
              else equityAndAccessDescriptionInfo
            ">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #equityAndAccessDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>
</form>
